import { ChangeDetectionStrategy, Component } from '@angular/core';
import { HeaderBaseComponent } from '@luggagehero/features/ui';

@Component({
  selector: 'lh-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HeaderComponent extends HeaderBaseComponent {}
